const dom = require('../utils/DOM');
const env = require('../utils/ENV');

const ACTIVE = '_active';

const OPTIONS_BY_TYPE = {
	issue: {
		asNavFor: 'issueNav',
		arrows: false,
		dots: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 9999,
				settings: 'unslick',
			},
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
				},
			},
		],
	},
	issueNav: {
		asNavFor: 'issue',
		arrows: false,
		dots: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 9999,
				settings: 'unslick',
			},
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					slidesToShow: 1,
				},
			},
		],
	},
	magazineList: {
		arrows: false,
		infinite: false,
		mobileFirst: true,
		swipeToSlide: true,
		variableWidth: true,
		waitForAnimate: false,
		focusOnSelect: true,
		slidesToScroll: 1,
		centerPadding: `${$('.content-area').width() - 240}px 0 0`,
		centerMode: true,
	},
	magazine: {
		infinite: false,
		swipeToSlide: true,
		variableWidth: true,
		waitForAnimate: false,
		focusOnSelect: true,
		slidesToScroll: 4,
		slidesToShow: Math.floor($('.magazine-single-body').width() / 128),
		centerMode: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToScroll: 1,
					arrows: false,
				},
			},
		],
	},
};

const CUSTOM_SETTINGS_BY_TYPE = {
	issue: {
		customOnChange: true,
	},
	issueNav: {
		customOnChange: true,
	},
	magazineList: {
		magazineList: true,
	},
};

function SlickSliders() {
	this.rebuild();
	dom.$window.on('resize orientationchange', () => {
		setTimeout(() => {
			this.update();
		}, 300);
	});
	dom.$window.focus(() => {
		this.update();
		setTimeout(() => {
			this.update();
		}, 300);
	});
}

SlickSliders.prototype = {
	rebuild: function() {
		var $sliders = $('[data-slider]');
		var totalSliders = $sliders.length;
		for (var k = 0; k < totalSliders; k++) {
			this._initSlider($sliders.eq(k));
		}
	},
	_initSlider: function($container) {
		var type = $container.attr('data-slider');
		$container.removeAttr('data-slider');

		this.$slides = $container.find('[data-slider-slides]');
		var totalSlides = this.$slides.children().length;
		var $total = $container.find('[data-slider-total]');
		var $prev = $container.find('[data-slider-prev]');
		var $next = $container.find('[data-slider-next]');
		var $whenActives = $container.find('[data-slider-when-active]');
		var $dotsContainer = $container.find('[data-slider-dots]');

		var $subSlides = $container.find('[data-slider-sub-slides]').children();
		var $previews = $container.find('[data-slider-previews]').children();
		var $subTabs = $('[data-slider-subslider="' + type + '"]');
		var self = this;

		if ($total) {
			$total.text(totalSlides + 1);
		}

		if (totalSlides > 0) {
			$container.find('[data-slider-total]').text(totalSlides);

			var options = {
				nextArrow: $next,
				prevArrow: $prev,
			};
			const typeOptions = OPTIONS_BY_TYPE[type];
			if (typeof typeOptions != 'undefined') {
				for (var i in typeOptions) {
					options[i] = typeOptions[i];

					if (i == 'asNavFor') {
						options[i] = $('[data-nav-slider="' + options[i] + '"]').find('[data-slider-slides]');
					}
				}
			}

			const customSettings = CUSTOM_SETTINGS_BY_TYPE[type] || {};

			options.accessibility = false; // See https://github.com/kenwheeler/slick/issues/1537
			this.$slides.slick(options);

			if (env.isDesktop) {
				var $area = this.$slides.find('*');
				var dragging = false;

				var DRAGGING = 'dragging';
				var DRAGGABLE = 'draggable';
				this.$slides.on('mousedown', function(e) {
					if (!dragging) {
						dragging = true;
						dom.$html.addClass(DRAGGING);
						$area.removeClass(DRAGGABLE).addClass(DRAGGING);
					}
				});

				dom.$window.on('mouseup blur', function(e) {
					if (dragging) {
						dragging = false;
						dom.$html.removeClass(DRAGGING);
						$area.addClass(DRAGGABLE).removeClass(DRAGGING);
					}
				});
			}

			if ($dotsContainer.length) {
				var $dots = $dotsContainer.children();
				$dots.click(e => {
					e.preventDefault();
					const next = parseInt($(e.currentTarget).index());
					this.$slides.slick('slickGoTo', next);
				});

				this.$slides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
					$dots
						.removeClass('_active')
						.eq(nextSlide)
						.addClass(ACTIVE);
				});

				$dots.first().addClass(ACTIVE);
			}

			var $current = $container.find('[data-slider-current]');
			if ($current.length) {
				this.$slides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
					$current.text(nextSlide + 1);
					TweenMax.fromTo($current, 0.35, { alpha: 0 }, { alpha: 1 });
				});

				$current.text(1);
			}

			if ($subSlides.length) {
				let index = 0;
				this.$slides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
					if (index != nextSlide) {
						index = nextSlide;
						$subSlides
							.stop()
							.hide()
							.eq(nextSlide)
							.fadeIn();
					}
				});

				$subSlides
					.hide()
					.first()
					.show();
			}

			if ($subTabs.length) {
				let index = 0;

				this.$slides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
					if (index != nextSlide) {
						index = nextSlide;
						$subTabs
							.children()
							.stop()
							.hide()
							.eq(nextSlide)
							.fadeIn();
					}
					self.update();
				});

				$subTabs
					.children()
					.hide()
					.first()
					.show();

				const $parentSlider = this.$slides;
				$subTabs
					.on('mouseenter', () => {
						$parentSlider.slick('slickPause');
					})
					.on('mouseleave', () => {
						$parentSlider.slick('slickPlay');
					});
			}

			if ($previews.length) {
				$previews.click(function(e) {
					e.preventDefault();
					this.$slides.slick('slickGoTo', $(this).index());
				});

				this.$slides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
					$previews
						.removeClass(ACTIVE)
						.eq(nextSlide)
						.addClass(ACTIVE);
				});
			}

			TweenMax.to($whenActives, 0.35, { alpha: 1 });

			if (customSettings.customOnChange) {
				this.$slides.on('afterChange', function(e, slick, currentSlide) {
					TweenMax.to(window, 0.3, { scrollTo: 0 });
				});
			}
			if (customSettings.magazineList) {
				this.$slides.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					let x = $('.content-area').width() - 240;
					slick.options.centerPadding = `${x}px 0 0`;
					if (nextSlide == slick.slideCount - 1) {
						slick.options.centerMode = true;
						x = x > 0 ? `0px 0 ${x - 16}px` : '0px';
						slick.options.centerPadding = x;
					} else {
						x = x > 0 ? `${x}px 0 0` : '0px';
						slick.options.centerPadding = x;
					}
				});
			}
		} else {
			$whenActives.remove();
		}
	},
	_buildNewSlides: function(data, $slider) {
		const hasData = !(!data || data == null || typeof data == 'undefined' || data.length == 0);

		if (hasData) {
			const newHTML = $(data);
			$slider.slickAdd(newHTML);
		}
	},
	moveSlider: function(direction) {
		const movePower = 50;
		TweenMax.to(this.$slides, 0.35, { x: direction * movePower });
	},
	update: function() {
		$('[data-slider-slides]').slick('setPosition');
	},
	scrollTo: function(slider, position) {
		$(slider).slick('setPosition');
		$(slider).slick('slickGoTo', parseInt(position));
	},
	add: function(slider, template) {
		$(slider).slick('slickAdd', template);
	},
	remove: function(slider) {
		var length = slider.find('.slick-slide').length + 3;
		for (var k = 0; k < length; k++) {
			var i = slider.find('.slick-slide').attr('data-slick-index');
			slider.slick('slickRemove', i);
			var j = 0;
			slider.find('.slick-slide').each(function() {
				$(this).attr('data-slick-index', j);
				j++;
			});
		}
	},
};

module.exports = new SlickSliders();
